import {
  LucideIcon,
  Settings,
  Building2,
  Palette,
  MessageSquare,
  Phone,
  SlidersHorizontal,
  Clock,
  Mail,
  FileText
} from 'lucide-react';

export interface Category {
  id: string;
  label: string;
  icon: LucideIcon;
  color: string;
  order: number;
}

const RULES: Array<{ match: (key: string) => boolean; category: Category }> = [
  {
    match: (k) => k.startsWith('system_'),
    category: { id: 'system', label: 'מערכת', icon: Settings, color: '#012A64', order: 1 }
  },
  {
    match: (k) => k.startsWith('company_'),
    category: { id: 'company', label: 'פרטי חברה', icon: Building2, color: '#0073ea', order: 2 }
  },
  {
    match: (k) => k.startsWith('theme_') || k.startsWith('primary_') || k.startsWith('logo_'),
    category: { id: 'branding', label: 'מיתוג ועיצוב', icon: Palette, color: '#8b5cf6', order: 3 }
  },
  {
    match: (k) => k.startsWith('welcome_'),
    category: { id: 'messaging', label: 'מסרים למשתמש', icon: MessageSquare, color: '#16a34a', order: 4 }
  },
  {
    match: (k) => k.startsWith('support_'),
    category: { id: 'support', label: 'תמיכה ויצירת קשר', icon: Phone, color: '#06b6d4', order: 5 }
  },
  {
    match: (k) => /_hours$|_minutes$|_days$/.test(k),
    category: { id: 'time', label: 'זמנים והגבלות', icon: Clock, color: '#f59e0b', order: 6 }
  },
  {
    match: (k) => k.startsWith('default_'),
    category: { id: 'defaults', label: 'ברירות מחדל', icon: SlidersHorizontal, color: '#f59e0b', order: 7 }
  },
  {
    match: (k) => k.startsWith('email_'),
    category: { id: 'email', label: 'תקשורת אימייל', icon: Mail, color: '#0073ea', order: 8 }
  },
  {
    match: (k) => k.startsWith('max_'),
    category: { id: 'limits', label: 'הגבלות', icon: SlidersHorizontal, color: '#dc2626', order: 9 }
  }
];

const FALLBACK: Category = {
  id: 'other',
  label: 'כללי',
  icon: FileText,
  color: '#676879',
  order: 99
};

export function categorize(parameterKey: string): Category {
  const key = parameterKey.trim().toLowerCase();
  for (const rule of RULES) {
    if (rule.match(key)) return rule.category;
  }
  return FALLBACK;
}
